// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\PackageCompositionResponse

import { hydratePackageCompositionDetail, type PackageCompositionDetail, type PackageCompositionDetailApiResponse } from './packageCompositionDetail.gen';

export type PackageCompositionApiResponse = {
	id: number;
	quantity: number;
	details: PackageCompositionDetailApiResponse[];
};

export type PackageComposition = {
	id: number;
	quantity: number;
	details: PackageCompositionDetail[];
};

export function hydratePackageComposition(data: PackageCompositionApiResponse): PackageComposition {
	return {
		...data,
		details: data.details.map(hydratePackageCompositionDetail),
	};
}